import React from 'react';

import AggregableMain from '../aggregable/AggregableMain';
import AggregableSummaryDataModel from '../aggregable/AggregableSummaryDataModel';

import GeneralColumnManager from './GeneralColumnManager';
import GeneralDataModel from './GeneralDataModel';
import GeneralSummaryView from './GeneralSummaryView';

export class GeneralMain extends AggregableMain {
  constructor(props) {
    super(props);

    this.summaryDataModel = new AggregableSummaryDataModel(this.counterparty.preferenceGroupName);

    this.dataModel = new GeneralDataModel(
      this.locale,
      this.counterparty,
      this.commandDataModel,
      this.summaryDataModel
    );

    this.columnManager = new GeneralColumnManager(
      this.session,
      this.counterparty
    );
    this.columnManager.settings.loadColumnSettings();
  }

  renderUsageSummaries() {
    return (
      <GeneralSummaryView
        dataModel={this.summaryDataModel}
        locale={this.locale}
      />
    );
  }
}
